import type { ReactNode } from 'react';
import { Provider } from 'urql';
import { graphqlClient } from './client';

export function GraphQLProvider({ children }: { children: ReactNode }) {
  return <Provider value={graphqlClient}>{children}</Provider>;
}
